import React from "react";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";

import fondoGris from "../../../assets/backgroundPhotos/fondogris_Dashport.jpg";

const useStyles = makeStyles({
  outer: {
    position: "relative",
    width: "100vw",
    left: "50%",
    right: "50%",
    marginLeft: "-50vw",
    marginRight: "-50vw",
    backgroundImage: `url(${fondoGris})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top",
    backgroundSize: "100%",
  },
});

const FullBleedBackground = ({ id, className, children }) => {
  const classes = useStyles();

  return (
    <div id={id} className={`${classes.outer} ${className || ""}`}>
      <Container maxWidth="md">{children}</Container>
    </div>
  );
};

export default FullBleedBackground;
